import { render, staticRenderFns } from "./LabKits.vue?vue&type=template&id=6a29b8f0&scoped=true&"
import script from "./LabKits.vue?vue&type=script&lang=js&"
export * from "./LabKits.vue?vue&type=script&lang=js&"
import style0 from "./LabKits.vue?vue&type=style&index=0&id=6a29b8f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a29b8f0",
  null
  
)

export default component.exports